export const ALL = 'all';
export const ALL_TITLE = 'ALL EVENTS';

export const UPCOMING = 'upcoming';
export const UPCOMING_TITLE = 'UPCOMING EVENTS';

export const PAST = 'past';
export const PAST_TITLE = 'PAST EVENTS';

export const DELETED = 'deleted';
export const DELETED_TITLE = 'DELETED EVENTS';

export default {
  ALL,
  ALL_TITLE,
  UPCOMING,
  UPCOMING_TITLE,
  PAST,
  PAST_TITLE,
  DELETED,
  DELETED_TITLE,
};
